import { Feature } from "ol";
import { KML } from "ol/format";

const parser = new DOMParser();
const kmlFormat = new KML();

export const getKmlFeatures = (kmlText: string | ArrayBuffer): Feature[] => {
    let replacedKml;
    const hasOuterBoundaryIs = (kmlText as string).includes("outerBoundaryIs");
    if (!hasOuterBoundaryIs) {
        replacedKml = (kmlText as string).replace(new RegExp("innerBoundaryIs", "g"), "outerBoundaryIs");
    }

    return kmlFormat.readFeatures(hasOuterBoundaryIs ? kmlText : replacedKml, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3059"
    });
};

export const extractStylesFromKML = (kml) => {
    const xmlDoc = parser.parseFromString(kml, "application/xml");
    const styleTags = xmlDoc.getElementsByTagName("Style");

    if (!styleTags?.length) {
        return;
    }
    const st = {};
    Array.from(styleTags).map((styleTag) => (st[styleTag.id] = styleTag.querySelector("color")?.innerHTML));

    return st;
};

export const getColorFromKmlStyles = (feature: Feature, styles): string => {
    const color = feature.get("COLOR");
    if (color) {
        return color;
    }
    const styleId = feature.get("styleUrl")?.split("#")[1];
    return styles && styleId && styles[styleId] ? "#" + styles[styleId] : "#FF6900";
};
